import { ColumnDef, DisplayOptions, FormatsState, Stage } from './types';
import { OperationCard } from './OperationCard';

interface OperationsCardsProps<T> {
  rows: T[];
  columns: ColumnDef<T>[];
  formats: FormatsState;
  display: DisplayOptions;
  titleColumnId?: string;
  stageAccessor?: (row: T) => Stage | undefined;
}

export function OperationsCards<T extends { id: string }>({
  rows,
  columns,
  formats,
  display,
  titleColumnId,
  stageAccessor,
}: OperationsCardsProps<T>) {
  if (rows.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-24 text-slate-400">
        <p className="text-sm font-medium">No records match these filters</p>
      </div>
    );
  }

  return (
    <div className="max-w-3xl mx-auto space-y-2">
      {rows.map((row) => (
        <OperationCard
          key={row.id}
          row={row}
          columns={columns}
          formats={formats}
          display={display}
          titleColumnId={titleColumnId}
          stageAccessor={stageAccessor}
        />
      ))}
    </div>
  );
}
